module.exports = __webpack_public_path__ + "static/img/wap_signin_logo_jxkj.4bfdd64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys/login/wap_signin_logo_jxkj.png
// module id = XzuC
// module chunks = 1